import React from 'react';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';

import { nl2br } from '../../../helpers';

import AvatarPopover from '../../AvatarPopover';

const MENTION_REGEX = /@\[(.+?)\]\(user:([0-9a-f-]{36})\)/g;

const parseMentions = (value, users, commentId) => {
  const mentionCounts = {};

  return value.replace(MENTION_REGEX, (match, name, uuid) => {
    const user = users?.find(u => u.uuid === uuid);
    if (!user) return `@${name}`;

    mentionCounts[uuid] = (mentionCounts[uuid] || 0) + 1;
    const index = mentionCounts[uuid];

    return `<span id="mention-${commentId}-${uuid}-${index}" className="comment-mention-display">@${user.name}</span>`;
  });
};

const collectMentionOccurrences = (value, users) => {
  const mentionCounts = {};

  return [...value.matchAll(MENTION_REGEX)].reduce((acc, match) => {
    const uuid = match[2];
    const user = users?.find(u => u.uuid === uuid);
    if (!user) return acc;

    mentionCounts[uuid] = (mentionCounts[uuid] || 0) + 1;

    return [...acc, { user, index: mentionCounts[uuid] }];
  }, []);
};

const CommentsMentionsRenderer = ({ comment }) => {
  const parsed = Parser(nl2br(parseMentions(comment.comment, comment.mentioned_users, comment.id)));
  const occurrences =
    collectMentionOccurrences(comment.comment, comment.mentioned_users, comment.id);

  return (
    <>
      {parsed}
      {occurrences.map(({ user, index }) => (
        <AvatarPopover
          key={`${user.uuid}-${index}`}
          user={user}
          targetId={`mention-${comment.id}-${user.uuid}-${index}`}
        />
      ))}
    </>
  );
};

CommentsMentionsRenderer.propTypes = {
  comment: PropTypes.object.isRequired,
};

export default CommentsMentionsRenderer;
